import type { WikiVehicleWeaponry } from "~~/types/gamedata";

export interface WeaponOverviewRow {
  key: "pilot" | "turret";
  icon: "weapon" | "turret";
  label: string;
  dps: number;
  alpha: number;
  /** Kein Wert vorhanden (z.B. keine Türme verbaut) — Zeile trotzdem zeigen, nur gedimmt. */
  muted: boolean;
}

/**
 * Piloten- und Turm-Waffen sind auf Vehicle-Ebene bereits getrennt aggregiert
 * (`weaponry.pilot_*`/`weaponry.turret_*`) — beide Zeilen werden immer
 * zurückgegeben (die leere `muted`), damit sofort sichtbar ist, welche
 * Waffenart das Schiff trägt. Geteilt zwischen dem "Allgemein"-Performance-Tab
 * und der Defense-Card-Kurzübersicht.
 */
export function getWeaponOverviewRows(weaponry: WikiVehicleWeaponry | null | undefined): WeaponOverviewRow[] {
  if (!weaponry) return [];
  return [
    { key: "pilot", icon: "weapon", label: "Pilot", dps: weaponry.pilot_dps ?? 0, alpha: weaponry.pilot_alpha ?? 0, muted: !weaponry.pilot_dps },
    { key: "turret", icon: "turret", label: "Turret", dps: weaponry.turret_dps ?? 0, alpha: weaponry.turret_alpha ?? 0, muted: !weaponry.turret_dps },
  ];
}

export function getMissileDamage(weaponry: WikiVehicleWeaponry | null | undefined): number | null {
  return weaponry?.total_missile_damage ?? weaponry?.missiles?.damage?.total ?? null;
}
